import { useEffect } from 'react'
import Game24 from './games/twentyfour/Game24'
import GameCryptic from './games/cryptic/GameCryptic'
import { STANDARD_CRYPTIC, EASY_CRYPTIC } from './games/cryptic/variant'
import GameRebus from './games/rebus/GameRebus'
import { Landing } from './Landing'
import { PanelSignup } from './games/twentyfour/components/PanelSignup'

// Thin path router for the nerdle labs suite:
//   /labs         → games landing
//   /labs/24      → the 24-game
//   /labs/cryptic → the cryptic game (also reachable via ?crypticbeta while in beta)
// No router library — a full page reload between landing and a game is fine for a static
// SPA. When the suite grows, add the game's slug here (and a card in Landing's GAMES).
function App() {
  const seg =
    typeof window !== 'undefined'
      ? window.location.pathname.replace(/\/+$/, '').split('/').pop() || ''
      : ''
  const search = typeof window !== 'undefined' ? window.location.search : ''

  // Which game are we on? (Shared by the tab title + routing below.) The static index.html
  // ships a "24-game" title; override it per game so e.g. the rebus tab doesn't read "24-game".
  const game: 'cryptic' | 'cryptic-easy' | 'rebus' | '24' | 'landing' =
    search.includes('crypticeasybeta') || seg === 'cryptic-easy'
      ? 'cryptic-easy'
      : search.includes('crypticbeta') || seg === 'cryptic'
      ? 'cryptic'
      : search.includes('rebusbeta') || seg === 'rebus'
      ? 'rebus'
      : seg === '24'
      ? '24'
      : 'landing'
  useEffect(() => {
    const title =
      game === 'cryptic-easy'
        ? 'cryptic (easier) · nerdle labs'
        : game === 'cryptic'
        ? 'cryptic · nerdle labs'
        : game === 'rebus'
        ? 'rebus · nerdle labs'
        : game === '24'
        ? '24-game · nerdle labs'
        : 'nerdle labs'
    document.title = title
  }, [game])

  // Test hook: /labs/24?paneltest renders the re-engagement sign-up card standalone,
  // so it can be exercised without completing a 10-test. Test rows land in BigQuery with
  // sessionId 'paneltest-…' (filterable). Remove/ignore in normal play.
  if (search.includes('paneltest')) {
    return (
      <PanelSignup
        sessionId={'paneltest-' + Date.now()}
        onDone={() => {
          window.location.href = '/labs/24'
        }}
      />
    )
  }

  // Beta hooks: ?crypticbeta / ?crypticeasybeta / ?rebusbeta render a game from any path so it can
  // be smoke-tested before its /labs/<slug> route is announced. Remove the hook once the game is live.
  if (search.includes('crypticeasybeta') || seg === 'cryptic-easy') return <GameCryptic variant={EASY_CRYPTIC} />
  if (search.includes('crypticbeta') || seg === 'cryptic') return <GameCryptic variant={STANDARD_CRYPTIC} />
  if (search.includes('rebusbeta') || seg === 'rebus') return <GameRebus />

  if (seg === '24') return <Game24 />
  return <Landing />
}

export default App
